import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { notifyLocalSqlitePersistError } from '@src/modules/platform/local-sqlite/infrastructure/localSqlitePersistError.ts';

let bound = false;

/** Flush SQLite snapshot when Capacitor pauses the native app (Android/iOS WebView). */
export function bindCapacitorAppPauseFlush(flush: () => Promise<void>): void {
  if (bound || !Capacitor.isNativePlatform()) return;
  bound = true;
  void App.addListener('pause', () => {
    void flush().catch((err) => {
      notifyLocalSqlitePersistError(err);
    });
  });
}

export function resetCapacitorAppPauseFlushForTests(): void {
  bound = false;
}
